import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { GraphicalViewPCComponent } from './graphical-view-pc.component';

const routes: Routes = [
  {
    path: '',
    component: GraphicalViewPCComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GraphicalViewPCRoutingModule { }